import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import * as AxiosLogger from "axios-logger";

const REQUEST_TIMEOUT_MS = 10000;
const ALLOW_NETWORK_LOG = process.env.REACT_APP_ALLOW_NETWORK_LOG === "true";

export class NetworkService {
  private readonly axiosInstance = axios.create({
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
    timeout: REQUEST_TIMEOUT_MS,
  });

  public static readonly shared = new NetworkService();
  private readonly baseUrl: string;

  private constructor() {
    this.baseUrl = process.env.REACT_APP_BASE_URL || "";
    console.log(`This base is ${this.baseUrl}`);
    if (ALLOW_NETWORK_LOG) {
      this.axiosInstance.interceptors.request.use(AxiosLogger.requestLogger);
      this.axiosInstance.interceptors.response.use(
        AxiosLogger.responseLogger,
        AxiosLogger.errorLogger
      );
    }
  }

  private getHeaders(): Promise<AxiosRequestConfig> {
    return Promise.resolve({
      headers: {},
    });
  }
  private extractData<TResponse>(
    axiosResponse: Promise<AxiosResponse<TResponse>>
  ): Promise<TResponse> {
    return axiosResponse.then((response) => response.data);
  }

  get<TResponse>(path: string): Promise<TResponse> {
    return this.extractData(
      this.getHeaders().then((headers) => {
        return this.axiosInstance.get<TResponse>(
          `${this.baseUrl}${path}`,
          headers
        );
      })
    );
  }

  post<TRequest, TResponse>(path: string, data: TRequest): Promise<TResponse> {
    return this.extractData(
      this.getHeaders().then((headers) => {
        return this.axiosInstance.post<TResponse>(
          `${this.baseUrl}${path}`,
          data,
          headers
        );
      })
    );
  }
}
